import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    SprayEntityIds,
    SprayEquipmentSetId,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { makeSelectEntitiesByCalibration } from './selectors';

export interface OwnProps {
    entityIds: SprayEntityIds;
    equipmentSetId: SprayEquipmentSetId;
    applicationRate: SprayApplicationRate;
}

interface ConnectedProps {
    blocksPerCalibration: string[];
}

type Props = OwnProps & ConnectedProps;

export class SummaryBlocksListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { blocksPerCalibration } = this.props;

        return (
            <Grid.Row>
                {blocksPerCalibration.map((blocks, index) => (
                    <Grid.Column mobile={16} tablet={8} computer={8} key={blocks}>
                        <ListItem
                            description={`Calibration #${index + 1}`}
                            value={blocks}
                        />
                    </Grid.Column>
                ))}
            </Grid.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    blocksPerCalibration: makeSelectEntitiesByCalibration()
});

export default connect(mapStateToProps)(SummaryBlocksListItemComponent);
